<template>
  <div>
    <v-card outlined>
      <v-card-title class="grey lighten-3">
        <slot name="title">{{ title }}</slot>
        <v-spacer></v-spacer>
        <!-- <v-btn v-if="allowIgnoreServiceLimitTIme" small color="secondary" v-on:click="changeIgnoreServiceLimitTimeButton()" :loading="loading">
          {{
            ignoreServiceLimitTime
              ? "Display Only Active Items"
              : "Display All Items"
          }}
        </v-btn> -->
        <v-switch
          v-if="allowIgnoreServiceLimitTIme"
          class="mt-0"
          v-model="showServiceLimitTime"
          label="Show active items"
          hide-details
        ></v-switch>
        <slot name="headerButtons"> </slot>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="filteredHeadersTable"
          dense
          :items="esvs"
          :footer-props="{
            'items-per-page-options': [15, 50, 100, -1],
          }"
          :items-per-page="50"
          @click:row="routeToEsv"
          :options.sync="options"
          :server-items-length="totalEsvs"
          multi-sort
          :loading="loading"
          :item-class="itemRowBackground"
          
        >
          <template v-slot:header="{ props: { headers } }">
            <tr v-show="$vuetify.breakpoint.smAndUp">
              <th v-for="header in headers" :key="header.value">
                <div
                  v-if="header.type === 'text'"
                  class="mx-2 font-weight-light"
                >
                  <v-text-field
                    dense
                    :label="header.text"
                    clearable
                    v-model="search[header.value]"
                    v-on:input="searchUpdated"
                    outlined
                  ></v-text-field>
                </div>
                <div
                  v-else-if="header.type === 'select'"
                  class="mx-2 font-weight-light"
                >
                  <v-select
                    dense
                    :label="header.text"
                    v-model="search[header.value]"
                    :items="headerSelects[header.value]"
                    v-on:change="searchUpdated"
                    outlined
                    clearable
                  ></v-select>
                </div>
                <div
                  v-else-if="header.type === 'multiselect'"
                  class="mx-2 font-weight-light"
                >
                  <v-select
                    dense
                    :label="header.text"
                    v-model="search[header.value]"
                    :items="headerSelects[header.value]"
                    v-on:change="searchUpdated"
                    outlined
                    clearable
                    multiple
                  ></v-select>
                </div>
              </th>
            </tr>
            <tr
              v-show="$vuetify.breakpoint.xsOnly"
              v-for="header in headers"
              :key="header.value"
            >
              <th>
                <div
                  v-if="header.type === 'text'"
                  class="mx-2 font-weight-light"
                >
                  <v-text-field
                    dense
                    :label="header.text"
                    clearable
                    v-model="search[header.value]"
                    v-on:input="searchUpdated"
                    outlined
                  ></v-text-field>
                </div>
                <div
                  v-else-if="header.type === 'select'"
                  class="mx-2 font-weight-light"
                >
                  <v-select
                    dense
                    :label="header.text"
                    v-model="search[header.value]"
                    :items="headerSelects[header.value]"
                    v-on:change="searchUpdated"
                    outlined
                    clearable
                  ></v-select>
                </div>
                <div
                  v-else-if="header.type === 'multiselect'"
                  class="mx-2 font-weight-light"
                >
                  <v-select
                    dense
                    :label="header.text"
                    v-model="search[header.value]"
                    :items="headerSelects[header.value]"
                    v-on:change="searchUpdated"
                    outlined
                    clearable
                    multiple
                  ></v-select>
                </div>
              </th>
            </tr>
          </template>
          <template v-slot:item.approvalStatus="{ item }">
            <approval-schematic :esv="item"></approval-schematic>
          </template>
          <template v-slot:item.translated="{ item }">
            <v-simple-checkbox v-model="item.translated" disabled></v-simple-checkbox>
          </template>
          <template v-slot:item.validated="{ item }">
            <v-simple-checkbox v-model="item.validated" disabled></v-simple-checkbox>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "DataTable",
  props: {
    title: {
      typeof: String,
      default: "Search Results",
    },
    optionsPassed: {
      typeof: Object,
      required: true,
    },
    totalEsvs: {
      typeof: Number,
      required: true,
    },
    esvs: {
      typeof: Array,
      required: true,
    },
    searchPassed: {
      typeof: Array,
      required: true,
    },
    headerSelects: {
      typeof: Array,
      required: true,
    },
    headersTable: {
      typeof: Array,
      required: true,
    },
    loading: Boolean,
    allowIgnoreServiceLimitTIme: {
      typeof: Boolean,
      default: true,
    },
    showHasApproved: {
      typeof: Boolean,
      default: false,
    },
    routeToDetails: {
      typeof: Boolean,
      default: true,
    },
  },
  components: {
    ApprovalSchematic: () => import("@/components/ESV/ApprovalSchematic.vue"),
  },
  data() {
    return {
      // loading: false,
      searchTimeOut: null,
      options: this.optionsPassed,
      search: this.searchPassed,
      showServiceLimitTime: true,
      pendingSearchUpdate: false,
    };
  },
  computed: {
    filteredHeadersTable() {
      if (this.search.serviceRequestType === 24) {
        return this.headersTable.filter(header => header.value !== 'serviceGrade');
      }
      return this.headersTable;
    }
  },
  methods: {
    routeToEsv(esv) {
      if (this.routeToDetails) {
        this.$router.push({ name: "ESV", params: { esvId: esv.id } });
      }
      else {
        this.$emit('row:click', esv);
      }
    },
    getStatusses() {
      if (this.headerSelects['status'] && this.headerSelects['status'].length > 0){
        this.$api
          .getStatusses()
          .then((resp) => (this.headerSelects["status"] = resp.data));
      }
    },
    getServiceRequestTypes() {
      this.$api
        .getServiceRequestTypes()
        .then((resp) => (this.headerSelects["serviceRequestType"] = resp.data));
    },
    getServiceGrades() {
      this.$api
        .getServiceGrades()
        .then((resp) => (this.headerSelects["serviceGrade"] = resp.data));
    },
    getProductGroups() {
      this.$api
        .getProductGroups()
        .then((resp) => (this.headerSelects["productGroup"] = resp.data));
    },
    getProductSubGroups() {
      this.$api
        .getProductSubGroups(this.search["productGroup"])
        .then((resp) => (this.headerSelects["productSubGroup"] = resp.data));
    },
  searchUpdated: _.throttle(function () {
      let sendSearch = {
        options: this.options,
        search: this.search,
        ignoreServiceLimitTime: !this.showServiceLimitTime,
      };
        this.$emit("getEsvs", sendSearch);
    }, 500),

    itemRowBackground(item) {
      if (!this.showServiceLimitTime) {
        //this.search["ignoreServiceLimitTime"]){
        return item.isActive ? "activeEsv cursor-pointer" : "inactiveEsv cursor-pointer";
      } else if (this.showHasApproved) {
        return item.hasApproved ? "activeEsv cursor-pointer" : "inactiveEsv cursor-pointer";
      }
      return "cursor-pointer";
    },
    onProductGroupSelect() {
      this.search["productSubGroup"] = null;
      this.getProductSubGroups();
    },
  },
  created() {
    this.$watch(() => this.search["productGroup"], this.onProductGroupSelect);
  },
  mounted() {
    this.getStatusses();
    this.getServiceRequestTypes();
    this.getServiceGrades();
    this.getProductGroups();
  },

  watch: {
    options: {
      handler() {
        this.searchUpdated();
      },
      deep: true
    },
    showServiceLimitTime: {
      handler() {
        if (this.loading) {
          this.pendingSearchUpdate = true;
        } else {
          this.searchUpdated();
        }
      },
    },
    loading: {
      handler(newValue) {
        if (!newValue && this.pendingSearchUpdate) {
          this.pendingSearchUpdate = false;
          this.searchUpdated();
        }
      },
    },
  },
};
</script>

<style >
.activeEsv {
  background-color: rgb(143, 255, 152);
}
.inactiveEsv {
  background-color: rgb(255, 124, 124);
}

</style>